import {BUILDING_DUST} from './buildingDustAnimation';

/**
 * Прилет жетона при размещении: жетон падает сверху, по дороге проявляясь и
 * уменьшаясь до своего размера, и в момент приземления бьет по земле — тогда
 * же играет звук постройки и поднимается пыль (см. playBuildingDropAnimation).
 *
 * Пока жетон летит, настоящий жетон на ячейке спрятан: летит его временный
 * двойник, который лежит ВЫШЕ пыли. Поэтому пыль выбивает из-под жетона, но
 * при этом накрывает соседние жетоны поля.
 */
export const BUILDING_DROP = {
  // ГЛАВНЫЙ ПАРАМЕТР СКОРОСТИ: сколько миллисекунд жетон летит до ячейки.
  // Меньше — резче удар, больше — тяжелее и медленнее падение
  durationMs: 390,
  // Высота старта в размерах ячейки
  heightFactor: 4.5,
  // Во сколько раз жетон крупнее своего обычного размера в начале полета
  startScaleFactor: 3,
  // Прозрачность на старте: жетон проявляется в полете
  startAlpha: 0,
  // Доля полета, за которую жетон проявляется полностью: дальше он падает уже
  // непрозрачным. На всю длительность проявление размазывалось, и жетон
  // «дорисовывался» у самой земли
  alphaFadeInShare: 1 / 3,
  // Тень жетона на ячейке: пока жетон падает, она проявляется от нуля до этой
  // прозрачности, а в момент удара о землю разом становится полной. Полная
  // тень под еще летящим жетоном выглядела слишком густой
  shadowFlightAlpha: 0.5,
};

/**
 * Сколько двойник держится над полем ПОСЛЕ приземления: ровно пока живет
 * самый долгий клуб пыли. Уберешь раньше — пыль на миг накроет сам жетон
 */
export const BUILDING_DROP_COVER_MS = BUILDING_DUST.delay.max + BUILDING_DUST.duration.max;
